export const PHONE_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 254;

const PHONE_ALLOWED_CHARACTERS = /^[0-9+().\-\s]*$/;
const PHONE_DISALLOWED_CHARACTERS = /[^0-9+().\-\s]/g;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const sanitizePhoneInput = (value: string) =>
  value.replace(PHONE_DISALLOWED_CHARACTERS, '').slice(0, PHONE_MAX_LENGTH);

export const isValidPhoneInput = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return true;
  if (
    trimmed.length > PHONE_MAX_LENGTH ||
    !PHONE_ALLOWED_CHARACTERS.test(trimmed)
  ) {
    return false;
  }

  const digitCount = (trimmed.match(/\d/g) || []).length;
  return digitCount >= 7 && digitCount <= 15;
};

export const isValidEmailInput = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return true;

  return trimmed.length <= EMAIL_MAX_LENGTH && EMAIL_PATTERN.test(trimmed);
};

export const isValidHttpUrlInput = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return true;

  try {
    const parsedUrl = new URL(trimmed);
    return (
      Boolean(parsedUrl.hostname) &&
      (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:')
    );
  } catch {
    return false;
  }
};
